import { api } from "./base"

import { alertsApi } from "./alerts"
import { devicesApi } from "./devices"
import { deviceGroupsApi } from "./deviceGroups"
import { usersApi } from "./users"

import { conductorsApi } from "./conductors"
import { powerlinesApi } from "./powerlines"
import { spansApi } from "./spans"
import { towersApi } from "./towers"
import { weatherServiceApi } from "./weatherService"

export { api } from "./base"

export const {
  // dashboard and telemetry related
  useDeviceTelemetryQuery,
  useLazyDeviceTelemetryQuery,
  useLazyDeviceTelemetryQualityQuery,
  useLastLocationsQuery,
  useUpdateLocationMutation,
  useDeleteLocationMutation,

  // orgs related
  useGeoQuery,
  useOrgsQuery,
  useOrgUsersQuery,
  useOrgUsersLogsQuery,
  useLazyOrgUsersLogsQuery,
  useRemoveOrgUserMutation,
  useUpdateOrgUserMutation,
  useUpdateOrgNameMutation,
  useUpdateOrgSettingsMutation,
  useUpdateOrgAuthMechanismsMutation,
} = api

export const {
  useAddPowerlineAlertSettingMutation,
  useAddDeviceAlertSettingMutation,
  useAlertsQuery,
  useLimitedAlertsQuery,
  useDeleteDeviceAlertSettingMutation,
  useDeletePowerlineAlertSettingMutation,
  useDeviceAlertTypesQuery,
  usePowerlineAlertTypesQuery,
  useGroupAlertsInfoQuery,
  useMarkAlertAsViewedMutation,
  useOrgAlertSettingsQuery,
  useOrgAlertSettingsStatesQuery,
  useUpdateDeviceAlertSettingMutation,
  useUpdatePowerlineAlertSettingMutation,
  useUpdateOrgAlertStateMutation,
  useAddTowerAlertSettingMutation,
  useUpdateTowerAlertSettingMutation,
  useDeleteTowerAlertSettingMutation,
  useTowerAlertTypesQuery,
} = alertsApi

export const {
  useActivateDeviceMutation,
  useCreateDeviceMutation,
  useDeleteDeviceMutation,
  useDeviceQuery,
  useDevicesQuery,
  useSellDeviceMutation,
  useUpdateDeviceNameMutation,
  useOrgDeviceStatusesQuery,
  useUpdateDeviceSettingsMutation,
  useEditableFeaturesQuery,
  useUpdateEditableFeaturesMutation,
} = devicesApi

export const {
  useAddDeviceToGroupMutation,
  useCreateGroupMutation,
  useDeleteGroupMutation,
  useDeviceGroupQuery,
  useDeviceGroupsQuery,
  useRemoveDeviceFromGroupMutation,
  useRemoveDevicesFromGroupMutation,
  useUpdateDeviceGroupNameMutation,
} = deviceGroupsApi

export const {
  useUserQuery,
  useUserUpdateMutation,
  useActivateUserMutation,
  useChangePasswordMutation,
  useCreateUserMutation,
  usePermanentTokenMutation,
  useRefreshTokenQuery,
  useResetPasswordMutation,
  useLoginMutation,
  useLoginOTPMutation,
  useLoginOAuthMutation,
  useValidateOAuthMutation,
  useSendRecoverEmailMutation,
  useUserOTPRegisterMutation,
  useUserOTPVerifyMutation,
  useUserOTPDisableMutation,
  useUserOTPRecoverGenerateMutation,
  useUsersLogsQuery,
  useUserTermsQuery,
  useAcceptUserTermsMutation,
} = usersApi

export const { useConductorsQuery, useConductorQuery, useLazyConductorQuery } =
  conductorsApi

export const {
  useLazyPowerlinesQuery,
  usePowerlineQuery,
  useLazyPowerlineQuery,
  usePowerlineGeoQuery,
  usePowerlineTelemetryQuery,
  useLazyPowerlineTelemetryQuery,
  useLazyPowerlineTelemetryQualityQuery,
  usePowerlineTelemetryValueSummaryQuery,
} = powerlinesApi

export const {
  usePowerlineSpansQuery,
  useLazyPowerlineSpansQuery,
  useSpansQuery,
  useSpanQuery,
  useLazySpanQuery,
  useSpanTelemetryQuery,
  useLazySpanTelemetryQuery,
  useLazySpanTelemetryQualityQuery,
} = spansApi

export const {
  usePowerlineTowersQuery,
  useLazyPowerlineTowersQuery,
  useTowersQuery,
  useTowerQuery,
  useTowerTelemetryQuery,
  useLazyTowerQuery,
  useLazyTowerTelemetryQuery,
  useLazyTowerTelemetryQualityQuery,
  useLazyTowersQuery,
} = towersApi

export const { useWeatherServiceQuery } = weatherServiceApi
